import { render, staticRenderFns } from "./ProjectStepActivity.vue?vue&type=template&id=2a099522&"
import script from "./ProjectStepActivity.vue?vue&type=script&lang=js&"
export * from "./ProjectStepActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports